import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Input,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import InputInline from "../Elements/InputInline";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { optionsBranch } from "../data/branch-data";
import { engApi } from "../api/engApi";
import { convertDateThai } from "../utils/function";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModalView from "../Components/ModalView";
import JobDetail from "../Components/JobDetail";
import { useReactToPrint } from "react-to-print";

const InternForm = () => {
  const { register, control, watch } = useForm();
  const [optionsInternType, setOptionsInternType] = useState([]);
  const [showModalSubmit, setShowModalSubmit] = useState(false);
  const [showModalPreview, setShowModalPreview] = useState(false);
  const allValue = watch();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getInternType = () => {
    engApi
      .get("/internship-date/")
      .then((res) => {
        const list = res.data.filter((el) => el.type != "4");

        const list2 = list.map((item) => {
          let text = "";

          if (item.type == 1) {
            text = `ฝึกงานภาคฤดูร้อน (2เดือน) วันที่ ${convertDateThai(
              item.start_date
            )} ถึง ${convertDateThai(item.stop_date)} `;
          } else if (item.type == 2) {
            text = `ฝึกงานภาคฤดูร้อน และสหกิจศึกษา (4เดือน) วันที่ ${convertDateThai(
              item.start_date
            )} ถึง ${convertDateThai(item.stop_date)}`;
          } else if (item.type == 3) {
            text = `ฝึกงานภาคฤดูร้อน และสหกิจศึกษา (6เดือน) วันที่ ${convertDateThai(
              item.start_date
            )} ถึง ${convertDateThai(item.stop_date)}`;
          }

          return {
            label: text,
            value: item.type,
          };
        });

        setOptionsInternType(list2);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getInternType();

    window.history.pushState({}, null, "/internship/interntest/");
  }, []);

  const displayCompanyDetail = (
    <Paper variant="elevation" sx={{ marginBlock: 3, padding: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="company.company_thainame"
            label="ชื่อสถานประกอบการ/หน่วยงาน (ภาษาไทย)"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="company.company_engname"
            label="Company name (English)"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="company.company_type"
            label="ประเภทธุรกิจ (Business cluster)"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputInline
            control={control}
            keyName="company.employees_qty"
            label="จำนวนพนักงานรวม (Number of employees)"
            endAdm="คน"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputInline
            control={control}
            keyName="company.working_days"
            label="จำนวนวันทำงาน (Working days per week)"
            endAdm="(วัน/สัปดาห์)"
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <InputInline
            control={control}
            keyName="company.address"
            label="ที่อยู่ (Address)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="company.sub_district"
            label="ตำบล/แขวง (Sub-district)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="company.district"
            label="อำเภอ/เขต (District)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="company.province"
            label="จังหวัด (Province)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="company.zip_code"
            label="รหัสไปรษณีย์ (zip code)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="company.cp_tel"
            label="โทรศัพท์ (Tel)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="company.cp_fax"
            label="โทรสาร (Fax)"
          />
        </Grid>
      </Grid>
    </Paper>
  );

  const displayContactPerson = (
    <Paper variant="elevation" sx={{ marginBlock: 3, padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1">
            ผู้ประสานงานที่สถานประกอบการมอบหมาย (contact person of company)
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <InputInline
            control={control}
            keyName="contact.full_name"
            label="ชื่อ-นามสกุล (Fullname)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="contact.position"
            label="ตำแหน่ง (Position)"
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <InputInline
            control={control}
            keyName="contact.department"
            label="แผนก/ฝ่าย (Department)"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InputInline
            control={control}
            keyName="contact.tel"
            label="โทรศัพท (Tel)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="contact.email"
            label="E-mail"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>นิสิตสามารถติดต่อสอบถามข้อมูลเพิ่มเติมได้ที่</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <RadioGroup row {...register("contact.contact_availabel.type")}>
            <FormControlLabel
              control={<Radio />}
              value={"1"}
              label="ผู้ประสานงาน"
            />
            <Box display="flex">
              <FormControlLabel
                value={"2"}
                control={<Radio />}
                sx={{ whiteSpace: "nowrap" }}
                label="อื่น ๆ เบอร์โทร"
              />
              <InputInline
                inline
                control={control}
                keyName="contact.contact_availabel.remark"
                label=""
              />
            </Box>
          </RadioGroup>
        </Grid>
      </Grid>
    </Paper>
  );

  const displayBranch = (
    <Box>
      <Paper variant="elevation" sx={{ marginBlock: 3 }}>
        <Typography p={3}>สาขาวิชาที่ต้องการรับ</Typography>
        {optionsBranch?.map((el, elIndex) => {
          return (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FormControlLabel
                  control={<Checkbox />}
                  label={el.label}
                  {...register(`branchs.${elIndex}.allow`)}
                />
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <input
                      className="d-none"
                      value={el.value}
                      {...register(`branchs.${elIndex}.b_id`)}
                    />
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.intern_qty`}
                      label="จำนวนนิสิต"
                      endAdm="คน"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      ช่วงเวลา (ท่านสามารถเลือกได้มากกว่า 1 ช่อง)
                    </Typography>

                    <Controller
                      // rules={{ required: true }}
                      control={control}
                      name={`branchs.${elIndex}.period.type`}
                      render={({ field }) => (
                        <RadioGroup {...field}>
                          {optionsInternType?.map((item) => {
                            return (
                              <>
                                <FormControlLabel
                                  control={<Radio />}
                                  value={item.value.toString()}
                                  label={item.label}
                                />
                              </>
                            );
                          })}
                          <FormControlLabel
                            control={<Radio />}
                            value="0"
                            label={
                              <Box display="flex">
                                <Typography variant="body1" whiteSpace="nowrap">
                                  อื่น ๆ โปรดระบุ
                                </Typography>
                                <Input
                                  className="input-form-response"
                                  sx={{ outline: "none", color: "#0032ff" }}
                                  {...register(
                                    `branchs.${elIndex}.period.remark`
                                  )}
                                />
                              </Box>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.position_title`}
                      label="ตำแหน่งงาน (Position Title)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.job_description`}
                      label="หน้าที่ความรับผิดชอบ (Job description)"
                      propsInput={{
                        multiline: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      หน่วยงานของท่านมีงานโครงงาน/ งานวิจัย
                      สำหรับนิสิตสหกิจศึกษา หรือไม่
                    </Typography>

                    <RadioGroup
                      {...register(`branchs.${elIndex}.project.have`)}
                    >
                      <FormControlLabel
                        value={"false"}
                        control={<Radio />}
                        label="ไม่มี"
                      />
                      <Box display="flex">
                        <FormControlLabel
                          value={"true"}
                          control={<Radio />}
                          sx={{ whiteSpace: "nowrap" }}
                          label="มี โปรดระบุ"
                        />
                        <Input
                          {...register(`branchs.${elIndex}.project.remark`)}
                          className="input-form-response"
                          sx={{ outline: "none", color: "#0032ff" }}
                        />
                      </Box>
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      คุณสมบัติเฉพาะด้านของนักศึกษาที่ต้องการ /Required skills
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.gender`}
                      label="เพศ (Gender)"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.gpax`}
                      label="เกรดเฉลี่ยสะสม (GPAX)"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.eng_ability`}
                      label="ภาษาอังกฤษ (English ability)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.programming_ability`}
                      label="มีพื้นฐานการใช้โปรแกรม (Basic programming)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputInline
                      control={control}
                      keyName={`branchs.${elIndex}.other_ability`}
                      label="อื่น ๆ (โปรดระบุ) Others (please specify)"
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Paper>
    </Box>
  );
  const displayJob = (
    <Paper variant="elevation" sx={{ marginBlock: 3, padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1">
            สาขาวิชาที่ต้องการ (กรอกข้อมูล 1 ชุด/1 สาขาวิชา)
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <InputInline control={control} keyName="branch_id" label="สาขาวิชา">
            <Select options={optionsBranch} />
          </InputInline>
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="allow_qty"
            label="จำนวนนิสิต"
            endAdm="คน"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="period"
            label="ช่วงเวลา (ท่านสามารถเลือกได้มากกว่า 1 ช่อง)"
          >
            <FormGroup>
              {optionsInternType?.map((item) => {
                return (
                  <FormControlLabel control={<Checkbox />} label={item.label} />
                );
              })}
              <FormControlLabel
                control={<Checkbox />}
                label={
                  <Box display="flex">
                    <Typography variant="body1" whiteSpace="nowrap">
                      อื่น ๆ โปรดระบุ
                    </Typography>
                    <Input
                      className="input-form-response"
                      sx={{ outline: "none", color: "#0032ff" }}
                    />
                  </Box>
                }
              />
            </FormGroup>
          </InputInline>
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="position_title"
            label="ตำแหน่งงาน (Position Title)"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="job_description"
            label="หน้าที่ความรับผิดชอบ (Job description)"
            propsInput={{
              multiline: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            หน่วยงานของท่านมีงานโครงงาน/ งานวิจัย สำหรับนิสิตสหกิจศึกษา หรือไม่
          </Typography>

          <RadioGroup name="radio-project-title">
            <FormControlLabel
              value={"false"}
              control={<Radio />}
              label="ไม่มี"
            />
            <Box display="flex">
              <FormControlLabel
                value={"true"}
                control={<Radio />}
                sx={{ whiteSpace: "nowrap" }}
                label="มี โปรดระบุ"
              />
              <Input
                className="input-form-response"
                sx={{ outline: "none", color: "#0032ff" }}
              />
            </Box>
          </RadioGroup>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            คุณสมบัติเฉพาะด้านของนักศึกษาที่ต้องการ /Required skills
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="gender"
            label="เพศ (Gender)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="gpax"
            label="เกรดเฉลี่ยสะสม (GPAX)"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InputInline
            control={control}
            keyName="eng_ability"
            label="ภาษาอังกฤษ (English ability)"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="programming_ability"
            label="มีพื้นฐานการใช้โปรแกรม (Basic programming)"
          />
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="other_ability"
            label="อื่น ๆ (โปรดระบุ) Others (please specify)"
          />
        </Grid>
      </Grid>
    </Paper>
  );
  const displayWelfare = (
    <Paper variant="elevation" sx={{ marginBlock: 3, padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1">
            สวัสดิการสำหรับนักศึกษาระหว่างปฏิบัติงาน (Remuneration and/or any
            other allowances.)
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="welfare.salary.wage"
            label={
              <FormControlLabel
                {...register("welfare.salary.have")}
                control={<Checkbox />}
                label="เบี้ยเลี้ยง/ค่าตอบแทน (Wage/Salary)"
              />
            }
            endAdm="บาท/วัน"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={<Checkbox />}
            label="ที่พัก(ถ้ามี)"
            {...register("welfare.dorm.have")}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <RadioGroup row {...register("welfare.dorm.expense")}>
            <FormControlLabel
              control={<Radio />}
              value={"false"}
              sx={{ whiteSpace: "nowrap" }}
              label="ไม่เสียค่าใช้จ่าย"
            />

            <InputInline
              inline
              control={control}
              keyName="welfare.dorm.price"
              label={
                <FormControlLabel
                  value={"true"}
                  control={<Radio />}
                  sx={{ whiteSpace: "nowrap" }}
                  label="เสียค่าใช้จ่าย"
                />
              }
              endAdm="บาท/เดือน (THB/month)"
            />
          </RadioGroup>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            {...register("welfare.transportation.have")}
            control={<Checkbox />}
            label="รถรับส่ง (ถ้ามี)"
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <RadioGroup row {...register("welfare.transportation.expense")}>
            <FormControlLabel
              control={<Radio />}
              value={"false"}
              sx={{ whiteSpace: "nowrap" }}
              label="ไม่เสียค่าใช้จ่าย"
            />

            <InputInline
              inline
              control={control}
              keyName="welfare.transportation.price"
              label={
                <FormControlLabel
                  value={"true"}
                  control={<Radio />}
                  sx={{ whiteSpace: "nowrap" }}
                  label="เสียค่าใช้จ่าย"
                />
              }
              endAdm="บาท/เดือน (THB/month)"
            />
          </RadioGroup>
        </Grid>
        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="welfare.food.remark"
            label={
              <FormControlLabel
                {...register("welfare.food.have")}
                control={<Checkbox />}
                label="สวัสดิการอาหาร"
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            สวัสดิการอื่น ๆ (ถ้ามีโปรดระบุ เช่น ชุดทำงาน อุปกรณ์) Others
            facilitiesor supports from company (if applicable, please specify)
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <InputInline
            control={control}
            keyName="welfare.other.remark"
            propsInput={{
              multiline: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {/* <Divider sx={{ border: "1px black solid" }} /> */}
          <hr />
          <Typography>
            คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา โทร. ๐ ๓๘๑๐ ๒๒๒๒ ต่อ ๓๓๑๕, ๓๓๒๔
            ไปรษณีย์อิเล็กทรอนิกส์ co-op@eng.buu.ac.th
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );

  return (
    <Container>
      <Box item xs={12} display="flex" alignItems="center" flexWrap="wrap">
        <img
          src="./assets/images/logo_no_bg.png"
          alt="buu logo"
          width="200px"
        />
        <Typography variant="h5" ml={2} color="#0032ff">
          แบบฟอร์มแจ้งรายละเอียดการฝึกงานและปฏิบัติงานสหกิจศึกษา
          <br /> สำหรับนิสิตคณะวิศวกรรมศาสตร์
        </Typography>
      </Box>
      <Box>
        <Typography m={2}>
          ตาม คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
          มีกำหนดการส่งนิสิตฝึกงานและปฏิบัติงานสหกิจประจำปี 2566
          เพื่อให้การฝึกงาและปฏิบัติสหกิจศึกษาสำหรับนิสิตคณะวิศวกรรมศาสตร์
          ดำเนินการไปด้วยความเรียบร้อยคณะวิศวกรรมศาสตร์จึงความอนุเคราะห์สอบถามความต้องการรับนิสิตเข้าฝึกงานและปฏิบัติสหกิจศึกษา
          ในหน่วยงานของท่าน ตามระยะเวลาดังกล่าวข้างต้น
        </Typography>
      </Box>

      {displayCompanyDetail}
      {displayContactPerson}
      {displayBranch}
      {/* {displayJob} */}
      {displayWelfare}

      {/* <Button variant="contained" onClick={() => setShowModalSubmit(true)}>
        บันทึกข้อมูล
      </Button> */}
      <Button variant="contained" onClick={() => setShowModalPreview(true)}>
        ตรวจสอบข้อมูล
      </Button>

      <ModalView
        isModaOpen={showModalSubmit}
        setIsModalOpen={setShowModalSubmit}
        title={<Typography variant="h6">ยืนยันการส่งข้อมูล</Typography>}
      >
        <Box
          sx={{
            maxWidth: "500px",
            height: "60px",
            width: "80vw",
          }}
          display="flex"
          justifyContent="flex-end"
          alignItems="end"
        >
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setShowModalSubmit(false)}
            >
              ยกเลิก
            </Button>

            <form method="post" action="./add-company-detail.php">
              <input
                className="d-none"
                value={JSON.stringify(allValue)}
                name="job_data"
              />

              <Button variant="contained" type="submit">
                ยืนยัน
              </Button>
            </form>
          </Stack>
        </Box>
      </ModalView>

      <ModalView
        isModaOpen={showModalPreview}
        setIsModalOpen={setShowModalPreview}
        title={<Typography variant="h6">ตรวจสอบข้อมูล</Typography>}
      >
        <Box sx={{ width: "100%", height: "50px", marginTop: "10px" }}>
          <Button onClick={handlePrint}>พิมพ์เอกสาร</Button>

          <form
            method="post"
            action="./add-company-detail.php"
            className="d-inline ms-2"
          >
            <input
              className="d-none"
              value={JSON.stringify(allValue)}
              name="job_data"
            />

            <Button variant="contained" type="submit">
              ยืนยัน
            </Button>
          </form>
        </Box>
        <Box sx={{ width: "100%", maxHeight: "70vh", overflowY: "auto" }}>
          <div
            className="sheet padding-20mm  react-print-container"
            ref={componentRef}
          >
            <JobDetail itemSelected={{ job_data: allValue }} />
          </div>
        </Box>
      </ModalView>
    </Container>
  );
};

export default InternForm;
